// The platform's message-text size: what every message body, and the 13px
// step fields beside it, read at. Size only, no colour, so a component with
// its own text colour (an Alert, for one) can use it as-is. App.jsx's
// MESSAGE_BODY_SX adds the secondary colour on top. MUI's body2 line-height
// (1.43) is a unitless multiplier, so restating it here scales correctly
// against this fontSize rather than body2's own default 14px.
export const MESSAGE_TEXT_SX = { fontSize: 13, lineHeight: 1.43 }
